// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export const validationLimits = {
  maxEmailsCount: 4,
  firstNameMinimumCharacterLength: 2,
  lastNameMinimumCharacterLength: 2,
};
